import { FunctionComponent as FC } from 'react';
import { Icon, hasBankImage } from 'vopay';
import type { CardBrand, Icons } from 'vopay';
import { PaymentMethodType } from '@/hooks/usePaymentMethods';
import type { PaymentMethod } from '@/hooks/usePaymentMethods';

const creditCardIconMap: Record<CardBrand, Icons> = {
  mastercard: 'cardMaster',
  visa: 'cardVisa',
  amex: 'cardAE',
  diners: 'cardDiners',
  discover: 'cardDiscover',
  jcb: 'cardJcb',
  uatp: 'creditCard',
  unionpay: 'creditCard',
  unknown: 'creditCard',
};

const paymentRailMap: Record<string, Icons> = {
  Email: 'mailGradient',
  EMAIL: 'mailGradient',
  PHONE: 'phoneGradient',
  MOBILE: 'phoneGradient',
  PhoneNumber: 'phoneGradient',
};

const defaultIconMap: Record<PaymentMethodType, Icons> = {
  BankAccount: 'bankDark',
  CreditCard: 'creditCard',
  Email: 'interacYellow',
  PhoneNumber: 'interacYellow',
  DebitCard: 'creditCard',
  GooglePay: 'googlePay',
  ApplePay: 'applePay',
  PayPal: 'paypal',
  Venmo: 'venmo',
  Zelle: 'zelle',
};

type PaymentMethodTypeIconProps = {
  method: PaymentMethodType;
  creditCardBrand?: CardBrand;
  bankId?: string;
  size?: string;
  kind?: PaymentMethod['kind'] | PaymentMethod['type'];
};

const PaymentMethodTypeIcon: FC<PaymentMethodTypeIconProps> = ({
  creditCardBrand,
  kind,
  method,
  bankId,
  size = '40px',
}) => {
  if (method === 'BankAccount' && bankId && hasBankImage(bankId)) {
    return (
      <img
        src={`https://embed-dev.vopay.com/images/logos-banks/${bankId}.svg`}
        alt="Bank Logo"
        style={{
          width: size,
          height: size,
        }}
      />
    );
  }

  if (['Email', 'PhoneNumber', 'PayPal', 'Venmo', 'Zelle'].includes(method)) {
    return (
      <Icon
        icon={paymentRailMap[kind as keyof typeof paymentRailMap]}
        size="xlg"
        color="none"
        width={size}
        height={size}
      />
    );
  }

  if (
    ['CreditCard', 'GooglePay', 'ApplePay'].includes(method) &&
    creditCardBrand &&
    creditCardIconMap[creditCardBrand]
  ) {
    return <Icon icon={creditCardIconMap[creditCardBrand]} size="xlg" color="none" width={size} height={size} />;
  }

  return <Icon icon={defaultIconMap[method] || 'dollar'} size="xlg" color="none" width={size} height={size} />;
};

export default PaymentMethodTypeIcon;
